import styled, { createGlobalStyle } from "styled-components";

export const PrintView = styled.div`
  .no-print,
  .ant-layout-sider,
  .ant-page-header-back {
    opacity: 0.7;
  }

  @media print {
    .no-print,
    .ant-layout-sider,
    .ant-page-header-back {
      display: none;
    }

    * {
      scrollbar-width: none;
    }
  }
`;

export const GlobalPrintStyle = createGlobalStyle`
  @media print {
    body {
      margin: 0;
      padding: 0;
      background: none;
    }

   
  #opendash-header{
    display: none;
  }
  
  .ant-layout{
  background: none;
  }
}
`;
